module.exports = {
    1: 'DANCE',
    2: 'FILM',
    3: 'VISUAL ARTS',
    4: 'BROADCAST ARTS',
    5: 'MUSIC',
    6: 'LITERATURE',
    7: 'THEATER',
    8: 'ARCHITECTURE',
    9: 'HISTORICAL'
};
